export default "__VITE_ASSET__$GGV0_GR__"